import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {PostDO} from '../data-objects/PostDO';
import {ActivatedRoute, Router} from '@angular/router';
import {IPageChangeData} from '../data-objects/IPageChangeData';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-base-grid-page',
  templateUrl: './base-grid-page.component.html',
  styleUrls: ['./base-grid-page.component.scss']
})
export class BaseGridPageComponent implements OnInit, OnDestroy {
  @Input() posts: PostDO[];
  @Input() isLoading: boolean;
  @Input() title: string;
  @Input() searchPlaceholder: string;
  @Input() itemsCount: number;
  @Input() pagesCount: number;
  @Input() thumbnailType: 'SONG' | 'CARTOON' | 'SEARCH' | 'CRAFT' | 'AUDIO';
  @Output() getData: EventEmitter<IPageChangeData> = new EventEmitter<IPageChangeData>();

  page = 1;
  searchText: string;

  private queryParamsSubscription: Subscription;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.queryParamsSubscription = this.activatedRoute.queryParamMap.subscribe((queryParams) => {
      this.page = Number(queryParams.get('page')) || 1;
      this.searchText = queryParams.get('q');
      this.getData.next({searchText: this.searchText || '', page: this.page});
    });
  }

  ngOnDestroy() {
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
  }

  search() {
    this.onPageChange(1);
  }

  resetSearch() {
    this.searchText = '';
    this.search();
  }

  onPageChange(page: number) {
    this.page = page;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        page: this.page,
        q: this.searchText
      },
      queryParamsHandling: 'merge',
    });
    this.getData.next({searchText: this.searchText, page: this.page});
  }
}
